import { Box, IconButton, Tooltip, Typography, useTheme } from 'hephaestus/web';
import { Close as CloseIcon } from 'hephaestus/webIcons';
import { useState } from 'react';

const STEPS = [
  'Select Portfolios',
  'Preview Trades',
  'Verify & Batch',
  'Execute',
];

const FlowBreadcrumb = () => {
  const theme = useTheme();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mt: 1.5,
        mb: -0.5,
        px: 1.5,
        py: 0.5,
        borderRadius: '4px',
        bgcolor: theme.color.surface,
        border: '1px solid',
        borderColor: theme.color.outlineVariant,
      }}
    >
      <Typography
        variant='labelSmall'
        sx={{
          color: theme.color.onSurfaceVariant,
          mr: 0.5,
          fontWeight: 700,
          textTransform: 'uppercase',
        }}
      >
        Flow
      </Typography>
      {STEPS.map((label, idx) => (
        <Box key={label} sx={{ display: 'flex', alignItems: 'center' }}>
          {idx > 0 && (
            <Typography
              variant='labelSmall'
              sx={{ mx: 0.5, color: theme.color.onDisabled }}
            >
              →
            </Typography>
          )}
          <Typography
            variant='labelSmall'
            sx={{ color: theme.color.onSurfaceVariant }}
          >
            {label}
          </Typography>
        </Box>
      ))}
      <Box sx={{ flex: 1 }} />
      <Tooltip title='Dismiss flow'>
        <IconButton
          onClick={() => setDismissed(true)}
          sx={{ p: 0.25 }}
          aria-label='Dismiss flow'
        >
          <CloseIcon
            sx={{ fontSize: 14, color: theme.color.onDisabled }}
            fontSize='inherit'
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FlowBreadcrumb;
